import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Select from "react-select";
import { colourStyles } from "../../utils/customSelectStyle";
import { eventDuration, eventTime,templateName } from "../../utils/constant";
import {createEvent} from "../../api";
import { createOrganizerEvent,deleteEvent } from "../../api";
import { use } from "../../assets/vendor/mixitup/src/module-definitions";
import { getAllCategories } from "../../api";
import { getAllCountries ,createQuickEventV2,getAllVenueOrganizer} from "../../api";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import { useNavigate } from "react-router-dom";
import NewTicketModal from "../Organizer/CreateQickEventV2/Components/NewTicketModal";
import TicketList from "../Organizer/CreateQickEventV2/Components/TicketList";
import ConfirmationDialog from "../../components/common/ConfirmationDialog";
import { EventFormData, TicketData, VenueData, TicketGroupData } from '../Organizer/CreateQickEventV2/types';
import ImageCropper from "../../components/common/ImageCropper/ImageCropper";
const CreateCalEvent = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [ticketKind, setTicketType] = useState<'single' | 'group'>('single');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventImage, setSelectedThumbImg] = useState<any>(null);
  const [categories,setCategories]= useState<any>([]);
  const [countries,setCountries]= useState<any>([]);
  const [type , setType] = useState<boolean>(false);
  const [editingTicket, setEditingTicket] = useState<TicketData | undefined>(undefined);
  const [ticket, setTickets] = useState<TicketData[]>([]);
  const [ticketGroups, setTicketGroups] = useState<TicketGroupData[]>([]);
  const [venues, setVenues] = useState<VenueData[]>([]);
  const [isCropperOpen, setIsCropperOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const hasMultipleVenues = false;
  const hasMultipleTicketGroups = false;
  const isTicketFree = false;
  
  const [confirmationDialog, setConfirmationDialog] = useState({
      isOpen: false,
      title: '',
      message: '',
      onConfirm: () => {},
      type: 'warning' as 'warning' | 'danger' | 'info' | 'success'
    });
    type OrganizerOption = {
        organizerId: string;
        name: string;
      };
      
      const [organizers, setOrganizers] = useState<OrganizerOption[]>([]);
      
      const venueDataRaw = localStorage.getItem("venueData");

      const venueId = React.useMemo(() => {
        if (!venueDataRaw) return "";
        try {
          const parsed = JSON.parse(venueDataRaw);
          return parsed?.userId ?? ""; 
        } catch {
          return "";
        }
      }, [venueDataRaw]);
      
  
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (!file) return;

      if (file.size > 3 * 1024 * 1024) {
        toast.error("File size should be less than 3MB");
        return;
      }

      setSelectedFile(file);
      setIsCropperOpen(true); 
    };



  const validationSchema = Yup.object({
    eventName: Yup.string().required("Event Name is required"),
    organizerId: Yup.string().required("Organizer is required"),
    eventDate: Yup.date().required("Event Date is required"),
    eventTime: Yup.string().required("Event Start Time is required"),
    // eventDuration: Yup.string().required("Event Duration is required"),
    endTime: Yup.string().required("Event End Time is required"),
    eventDescription: Yup.string().required("Event Description is required"),
    shortDescription: Yup.string().required("Short Description is required"),
    // templateName: Yup.string().required("Template Name is required"), 
    // countryName:Yup.string().required("Country Name is required"),
    // categoryName:Yup.string().required("Category Name is required"),
    tickets: Yup.array()
    .of(Yup.object()) 
    .min(1, "You must create at least one ticket"),
  venueDetails: Yup.object({
    name: Yup.string().required("Venue name is required"),
  }),

  });

  const formik = useFormik({
    initialValues: {
      eventName: "",
      organizerId: "",
      eventDate: "",
      eventTime: "",
      endTime: "",
      eventDescription: "",
      eventLocation: "",
      eventImage: "" ,
      shortDescription: "",
      templateType: "club",
      categoryName:"",
      countryName :"",
      isOtherAttendeeRequired: false,  
      hasTermsAndConditions: false,
      termsAndConditions: "",
      venueDetails: {
      name: "",
      addressLine1: "",
      addressLine2: "",
      country: "",
      state: "",
      city: "",
      zipCode: "",
      latitude: undefined as number | undefined,
      longitude: undefined as number | undefined,
    },
    },
    
    
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (ticket.length === 0) {
        toast.error("You must create at least one ticket");
        return; 
      }
      setIsLoading(true);
      try {
       const fd = new FormData();
      fd.append("eventName", values.eventName);
      fd.append("organizerId", values.organizerId);
      fd.append("eventDescription", values.eventDescription);
      fd.append("shortDescription", values.shortDescription);
      fd.append("eventLocation", values.eventLocation);
      fd.append("categoryId", "11");
      fd.append("ticketType", "paid");
      fd.append("paymentChannel", "our");
      fd.append("paymentUrl", "");
      fd.append("eventType", "offline");
      fd.append("onlineEventType", "offline");
      fd.append("eventStatus", "active");
      fd.append("eventDate", values.eventDate);
      fd.append("eventTime", values.eventTime);
      fd.append("endTime", values.endTime);
      fd.append("eventVenue", values.eventLocation);
      fd.append("eventAddress1", values.eventLocation);
      fd.append("templateType", "club");
      fd.append("processingFee", "2.7");
      fd.append("ticketFee", "0.50");
      fd.append("showOtherFees", "true");
      fd.append("ticketStatus", "open");
      fd.append("ticketGrouping", "single_with_grouping");
      fd.append("platformFee", "1");
      fd.append("userType", "venue");
      fd.append("sourceOfCreation", "mobile");
      fd.append("isOtherAttendeeRequired", String(values.isOtherAttendeeRequired));
      fd.append("hasTermsAndConditions", String(values.hasTermsAndConditions));
      fd.append("termsAndConditions", values.termsAndConditions || "");
      fd.append(
        "tickets",
        JSON.stringify(
          ticket.map((t) => ({
            name: t.name,
            type: t.type,
            price: Number(t.price),
            totalTickets: Number(t.totalTickets),
            isActive: t.isActive,
            description: t.description ?? "",
            ticketOrder: t.ticketOrder || ticket.length + 1,
            venueId: t.venueId ?? null,
            groupTicketPrice: t.type === "group" ? Number(t.price) : null,
            isGroupTicket: t.type === "group",
            groupTicketCount: t.groupTicketCount ?? null,
            ticketGroupId: t.ticketGroupId ?? null,
            isOfferActive: t.isOfferActive || false,
            previousAmount: t.previousAmount ?? null,
          }))
        )
      );
      if (eventImage instanceof File) {
        fd.append("eventImage", eventImage, eventImage.name);
      }
      fd.append("venueDetails", JSON.stringify(values.venueDetails));
      const response = await createQuickEventV2(fd);
      console.log("createEvent response:", JSON.stringify(response));
      console.log("createEvent fd:", JSON.stringify(fd));
        if (response) {
          toast.success("Event created successfully");
          setTimeout(() => {
          navigate(`/home`);
          }, 2000);
        } else {
          toast.error("Failed to create event");
        }
        formik.resetForm();
        setSelectedThumbImg(null);
      }  catch (error: any) {
        console.error("Full error:", error);
      }
      finally {
        setIsLoading(false);
      }
    },
  });
  useEffect(() => {
    const getCategories = async () => {
      try {
        const response = await getAllCategories();
        console.log("response", response);
        setCategories(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);
  useEffect(() => {
    const getCountries = async () => {
      try {
        const response = await getAllCountries();
        console.log("response", response);
        setCountries(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    getCountries();
  }, []);
  const closeConfirmationDialog = () => {
    setConfirmationDialog(prev => ({ ...prev, isOpen: false }));
  };
  useEffect(() => {
    if (!venueId) return;
  
    const loadVenueOrganizers = async () => {
      try {
        const res = await getAllVenueOrganizer(venueId);
        setOrganizers(res);
      } catch (error) {
        console.error("Failed to load organizers", error);
      }
    };
  
    loadVenueOrganizers();
  }, [venueId]);
  console.log("Venue ID for organizer fetch:", venueId);  

  // Handle opening modal for specific ticket type
  const openModal = (type: 'single' | 'group') => {
    setTicketType(type);
    setIsModalOpen(true);
  };
  const handleTicketSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      if (editingTicket) {
        setTickets(prev =>
          prev.map(ticket =>
            ticket.id === editingTicket.id
              ? {
                  ...ticket,
                  name: values.ticketType,
                  description: values.description,
                  price: isTicketFree ? 0 : values.price,
                  totalTickets: values.maxCount === 0 || isNaN(values.maxCount) ? null : values.maxCount,
                  groupTicketCount: ticketKind === 'group' ? values.groupTicketCount : undefined,
                  venueId: hasMultipleVenues ? values.venueId : undefined,
                  ticketGroupId: hasMultipleTicketGroups ? values.ticketGroupId : undefined,
                  isOfferActive: values.isOfferActive || false,
                  previousAmount: values.isOfferActive ? values.previousAmount : undefined,
                  ticketOrder: values.ticketOrder,
                }
              : ticket
          )
        );
      } else {
        const newTicket: TicketData = {
          id: Date.now().toString(),
          name: values.ticketType,
          type: ticketKind,
          description: values.description,
          price: isTicketFree ? 0 : values.price,
          totalTickets: values.maxCount === 0 || isNaN(values.maxCount) ? null : values.maxCount,
          maxPerCustomer: -1,
          ticketOrder: values.ticketOrder || ticket.length + 1,
          earlyBirdDiscount: false,
          discountAmount: 0,
          discountType: 'percentage',
          discountEndDate: '',
          discountEndTime: '',
          isActive: true,
          groupTicketCount: ticketKind === 'group' ? values.groupTicketCount : undefined,
          venueId: hasMultipleVenues ? values.venueId : undefined,
          ticketGroupId: hasMultipleTicketGroups ? values.ticketGroupId : undefined,
          isOfferActive: values.isOfferActive || false,
          previousAmount: values.isOfferActive ? values.previousAmount : undefined,
        };
        setTickets(prev => [...prev, newTicket]);
      }
      setEditingTicket(undefined);
      setIsModalOpen(false);
    } finally {
      setIsLoading(false);
    }
  };
  const onEditTicket = (ticket: TicketData) => {
        setEditingTicket(ticket);
        setTicketType(ticket.type);
        setIsModalOpen(true);
      console.log('onEditTicket', ticket);
    };

    const toggleModal = () => {
      if (isModalOpen) {
        setEditingTicket(undefined);
  
        if (!editingTicket) {
          setTicketType('single');
        }
      }
      setIsModalOpen(!isModalOpen);
      setType(false);
    };
    const handleTicketToggle = (ticketId: string, isActive: boolean) => {
        setTickets(prev => prev.map(ticket =>
          ticket.id === ticketId ? { ...ticket, isActive } : ticket
        ));
      };

      const onDeleteTicket = (ticketId: string) => {
        const ticketToDelete = ticket.find(t => t.id === ticketId);
        if (ticketToDelete) {
          setConfirmationDialog({
            isOpen: true,
            title: "Delete Ticket",
            message: `Are you sure you want to delete <strong>${ticketToDelete.name}</strong>?`,
            onConfirm: () => setTickets(prev => prev.filter(t => t.id !== ticketId)),
            type: "danger",
          });
        }
      };
      const onCheckboxChange = (name: string, value: boolean) => {
        formik.setFieldValue(name, value);
      };
      // Handle Google Map location selection for single venue
      const handleSingleVenueLocationChange = (location: {
      name?: string;
      latitude?: number;
      longitude?: number;
      formattedAddress?: string;
      addressLine1?: string;
      addressLine2?: string;
      country?: string;
      state?: string;
      city?: string;
      zipCode?: string;
    }) => {
      const venueDetails = {
        name: location.name || "",
        addressLine1: location.formattedAddress || "",
        addressLine2: location.addressLine2 || "",
        country: location.country || "",
        state: location.state || "",
        city: location.city || "",
        zipCode: location.zipCode || "",
        latitude: location.latitude,
        longitude: location.longitude,
      };
      formik.setFieldValue("venueDetails", venueDetails);
    };



  return (
    <div className="col-md-12">
      <div className="event-dt-block p-10">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12">
              <div className="main-title text-center">
                <h3>Create Event</h3>
              </div>
            </div>
            <div className="col-xl-8 col-lg-9 col-md-12">
              <div className="wizard-steps-block">
                <div id="add-event-tab" className="step-app">
                  <div className="step-content"></div>
                  <div
                    className="step-tab-panel step-tab-info active"
                    id="tab_step1"
                  >
                    <div className="tab-from-content">
                      <div className="main-card">
                        <div className="bp-title">
                          <h4>
                            <i className="fa-solid fa-circle-info step_icon me-3"></i>
                            Details
                          </h4>
                        </div>
                        <div className="p-2 bp-form main-form">
                          <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                              <div className="col-lg-12 col-md-12">

                              <label className="form-label fs-16 mb-1">
                                    Select Organizer <span className="text-danger">*</span>
                                </label>

                                <div className="search-group position-relative w-100 mb-2">
                                    <select
                                    className="form-control h_40 ps-4"
                                    name="organizerId"
                                    value={formik.values.organizerId}
                                    onChange={(e) =>
                                        formik.setFieldValue("organizerId", e.target.value)
                                    }
                                    onBlur={formik.handleBlur}
                                    >
                                    <option value="">Choose organizer</option>

                                    {organizers.map((o) => (
                                        <option key={o.organizerId} value={o.organizerId}>
                                        {o.name}
                                        </option>
                                    ))}
                                    </select>

                                    <i className="uil uil-user position-absolute start-0 top-50 translate-middle-y ms-2" />
                                </div>

                                {formik.touched.organizerId && formik.errors.organizerId && (
                                    <div className="text-danger mt-1">
                                    {formik.errors.organizerId}
                                    </div>
                                )}
                                {/* Event Name */}
                                <div className="form-group border_bottom pb_30">
                                  <label className="form-label fs-16">
                                    Give your event a name.*
                                  </label>
                                  <input
                                    className="form-control h_50"
                                    type="text"
                                    placeholder="Enter event name here"
                                    name="eventName"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.eventName}
                                  />
                                  {formik.touched.eventName &&
                                    formik.errors.eventName && (
                                      <div className="text-danger">
                                        {formik.errors.eventName}
                                      </div>
                                    )}
                                </div>

                                {/* Event Date and Time */}
                                <div className="form-group border_bottom pt_30 pb_30">
                                  <label className="form-label fs-16">
                                    When is your event?*
                                  </label>
                                  <div className="row g-2">
                                    <div className="col-md-6">
                                      <label className="form-label mt-3 fs-6">
                                        Event Date.*
                                      </label>
                                      <input
                                        className="form-control h_50"
                                        type="date"
                                        name="eventDate"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.eventDate}
                                      />
                                      {formik.touched.eventDate &&
                                        formik.errors.eventDate && (
                                          <div className="text-danger">
                                            {formik.errors.eventDate}
                                          </div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                      <div className="row g-2">
                                        <div className="col-md-6">
                                          <label className="form-label mt-3 fs-6">
                                            Start Time
                                          </label>
                                          <Select
                                            className="eventox-select"
                                            options={eventTime}
                                            styles={colourStyles}
                                            onChange={(val) =>
                                              formik.setFieldValue(
                                                "eventTime",
                                                (val as { value: string })
                                                  ?.value || ""
                                              )
                                            }
                                          />
                                          {formik.touched.eventTime &&
                                            formik.errors.eventTime && (
                                              <div className="text-danger">
                                                {formik.errors.eventTime}
                                              </div>
                                            )}
                                        </div>
                                         <div className="col-md-6">
                                          <label className="form-label mt-3 fs-6">
                                            End Time
                                          </label>
                                          <Select
                                              className="eventox-select"
                                              options={eventTime}
                                              styles={colourStyles}
                                              value={eventTime.find(option => option.value === formik.values.endTime) || null}
                                              onChange={(val) =>
                                                formik.setFieldValue("endTime", (val as { value: string })?.value || "")
                                              }
                                            />
                                          {formik.touched.endTime &&
                                            formik.errors.endTime && (
                                              <div className="text-danger">
                                                {formik.errors.endTime}
                                              </div>
                                            )}
                                        </div>
                                        {/* <div className="col-md-6">
                                          <label className="form-label mt-3 fs-6">
                                            Duration
                                          </label>
                                          <Select
                                            className="eventox-select"
                                            options={eventDuration}
                                            styles={colourStyles}
                                            value={eventDuration.find(option => option.value === formik.values.eventDuration) || null}
                                            onChange={(val) =>
                                              formik.setFieldValue(
                                                "eventDuration",
                                                (val as { value: string })?.value || ""
                                              )
                                            }
                                          />
                                          {formik.touched.eventDuration &&
                                            formik.errors.eventDuration && (
                                              <div className="text-danger">
                                                {formik.errors.eventDuration}
                                              </div>
                                            )}
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* Event Banner */}
                               <div className="form-group pt_30 pb_30">
                                  <label className="form-label fs-16">
                                    Add a few images to your event banner.
                                  </label>
                                  <p className="mt-2 fs-14 d-block mb-3 pe_right">
                                    Upload colorful and vibrant images as the banner for your event! See how beautiful images help your event details page.
                                  </p>
                                  <div className="content-holder mt-4">
                                    <div className="default-event-thumb">
                                      <div
                                        className="default-event-thumb-btn"
                                        onClick={() => fileInputRef.current?.click()}
                                      >
                                        <div className="thumb-change-btn">
                                          <input
                                            type="file"
                                            id="eventImage"
                                            ref={fileInputRef}
                                            onChange={handleImageUpload}
                                            style={{ display: "none" }}
                                            accept="image/jpeg, image/png"
                                          />
                                          <label style={{ cursor: "pointer" }}>
                                            Select Image
                                          </label>
                                        </div>
                                      </div>
                                      {eventImage && (
                                        <img
                                          src={URL.createObjectURL(eventImage)}
                                          alt="Uploaded Preview"
                                          style={{ maxWidth: "100%", maxHeight: "200px", marginTop: "15px" }}
                                        />
                                      )}
                                    </div>
                                  </div>
                                  {formik.touched.eventImage && formik.errors.eventImage && (
                                    <div className="text-danger mt-2">{formik.errors.eventImage}</div>
                                  )}
                                </div>
                                {/* === Cropper Modal === */}
                                {isCropperOpen && selectedFile && (
                                  <div
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      zIndex: 2000,
                                      overflowY: "auto",
                                      padding: "20px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#fff",
                                        padding: "20px",
                                        borderRadius: "10px",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                                        maxWidth: "600px",     
                                        width: "90%",          
                                        maxHeight: "90vh",     
                                        overflowY: "auto",
                                      }}
                                    >
                                      <ImageCropper
                                        imageFile={selectedFile}
                                        onCropComplete={(croppedFile) => {
                                          formik.setFieldValue("eventImage", croppedFile);
                                          setSelectedThumbImg(croppedFile); 
                                          setIsCropperOpen(false);
                                        }}
                                      />

                                      {/* Button Row */}
                                      <div
                                        style={{
                                          marginTop: "20px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "5px",
                                        }}
                                      >
                                        <button
                                          className="btn btn-outline-danger"
                                          onClick={() => setIsCropperOpen(false)}
                                          style={{
                                            minWidth: "85px",
                                            height: "32px",
                                            borderRadius: "8px",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                          }}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Event Description */}
                                <div className="form-group border_bottom pb_30">
                                  <label className="form-label fs-16">
                                    Please describe your event.
                                  </label>
                                   <p className="mt-2 fs-14 d-block mb-3">
                                    Write a few words below to describe your event and provide
                                    any extra information such as schedules, itinerary or any
                                    special instructions required to attend your event.
                                  </p>
                                  <ReactQuill
                                    className="text-editor mt-4"
                                    value={formik.values.eventDescription}
                                    onChange={(value) => {
                                      formik.setFieldValue("eventDescription", value);
                                    }}
                                    onBlur={() => {
                                      formik.setFieldTouched("eventDescription", true);
                                    }}
                                  />
                                  {formik.touched.eventDescription &&
                                    formik.errors.eventDescription && (
                                      <div className="text-danger">
                                        {formik.errors.eventDescription}
                                      </div>
                                    )}
                                </div>

                                {/* Short Description */}
                                <div className="form-group border_bottom pb_30">
                                  <label className="form-label fs-16">
                                    Please describe your event in short.
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter short description here"
                                    name="shortDescription"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.shortDescription}
                                  />
                                  {formik.touched.shortDescription &&
                                    formik.errors.shortDescription && (
                                      <div className="text-danger">
                                        {formik.errors.shortDescription}
                                      </div>
                                    )}
                                </div>

                                {/* Event Location */}
                              <div className="col-md-12">
                              <div className="google-places-container">
                                <label className="form-label">
                                  <i className="fa-solid fa-map-marker-alt me-2"></i>
                                  Event Location *
                                </label>
                                <GooglePlacesAutocomplete
                                 
                                  apiKey={
                                    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
                                    ""
                                  }
                                  selectProps={{
                                    placeholder:
                                      "Search for a location or address...",
                                    isClearable: true,
                                    value: formik.values.venueDetails?.name ? {
                                      label: formik.values.venueDetails.name,
                                      value: {
                                        description: formik.values.venueDetails.addressLine1,
                                        place_id: formik.values.venueDetails.name,
                                        geometry: {
                                          location: {
                                            lat: formik.values.venueDetails.latitude,
                                            lng: formik.values.venueDetails.longitude
                                          }
                                        }
                                      }
                                    } : null,
                                    onChange: (place: any) => {
                                      if (place) {
                                        console.log("Selected place:", place);

                                        // Extract detailed place information
                                        const placeDetails = {
                                          name: place.label || "",
                                          formattedAddress: place.label || "",
                                          addressLine1:
                                            place.value?.description || "",
                                          addressLine2: "",
                                          country: "",
                                          state: "",
                                          city: "",
                                          zipCode: "",
                                          latitude:
                                            place.value?.geometry?.location
                                              ?.lat,
                                          longitude:
                                            place.value?.geometry?.location
                                              ?.lng,
                                        };

                                        // If we have place details, try to extract address components
                                        if (place.value?.place_id) {
                                          // Use Google Places API to get detailed address components
                                          const geocoder =
                                            new google.maps.Geocoder();
                                          geocoder.geocode(
                                            { placeId: place.value.place_id },
                                            (results, status) => {
                                              if (
                                                status === "OK" &&
                                                results &&
                                                results[0]
                                              ) {
                                                const result = results[0];
                                                const addressComponents =
                                                  result.address_components;

                                                // Extract address components
                                                const placeDetailsEnhanced = {
                                                  name: place.label || "",
                                                  formattedAddress:
                                                    result.formatted_address ||
                                                    place.label ||
                                                    "",
                                                  addressLine1:
                                                    result.formatted_address ||
                                                    place.value?.description ||
                                                    "",
                                                  addressLine2: "",
                                                  country: "",
                                                  state: "",
                                                  city: "",
                                                  zipCode: "",
                                                  latitude:
                                                    result.geometry?.location?.lat(),
                                                  longitude:
                                                    result.geometry?.location?.lng(),
                                                };

                                                // Parse address components
                                                addressComponents.forEach(
                                                  (component) => {
                                                    const types =
                                                      component.types;

                                                    if (
                                                      types.includes("country")
                                                    ) {
                                                      placeDetailsEnhanced.country =
                                                        component.long_name;
                                                    } else if (
                                                      types.includes(
                                                        "administrative_area_level_1"
                                                      )
                                                    ) {
                                                      placeDetailsEnhanced.state =
                                                        component.long_name;
                                                    } else if (
                                                      types.includes("locality")
                                                    ) {
                                                      placeDetailsEnhanced.city =
                                                        component.long_name;
                                                    } else if (
                                                      types.includes(
                                                        "postal_code"
                                                      )
                                                    ) {
                                                      placeDetailsEnhanced.zipCode =
                                                        component.long_name;
                                                    } else if (
                                                      types.includes("route")
                                                    ) {
                                                      placeDetailsEnhanced.addressLine1 =
                                                        component.long_name;
                                                    } else if (
                                                      types.includes(
                                                        "street_number"
                                                      )
                                                    ) {
                                                      placeDetailsEnhanced.addressLine1 =
                                                        component.long_name +
                                                        " " +
                                                        placeDetailsEnhanced.addressLine1;
                                                    }
                                                  }
                                                );

                                                // Update venue details with enhanced information
                                                handleSingleVenueLocationChange(
                                                  placeDetailsEnhanced
                                                );

                                                // handleInputChange('venue', placeDetailsEnhanced.formattedAddress);

                                                console.log(
                                                  "Enhanced place details:",
                                                  placeDetailsEnhanced
                                                );
                                              } else {
                                                // Fallback to basic place details
                                                handleSingleVenueLocationChange(
                                                  placeDetails
                                                );
                                                // handleInputChange('venue', place.label || '');
                                              }
                                            }
                                          );
                                        } else {
                                          // Fallback to basic place details
                                          handleSingleVenueLocationChange(
                                            placeDetails
                                          );
                                          // handleInputChange('venue', place.label || '');
                                        }
                                      } else {
                                        // Handle clear action - reset venue details
                                        console.log("Location cleared");
                                        handleSingleVenueLocationChange({
                                          name: '',
                                          formattedAddress: '',
                                          addressLine1: '',
                                          addressLine2: '',
                                          country: '',
                                          state: '',
                                          city: '',
                                          zipCode: '',
                                          latitude: undefined,
                                          longitude: undefined,
                                        });
                                      }
                                    },
                                    styles: {
                                      control: (provided: any, state: any) => ({
                                        ...provided,
                                        minHeight: "48px",
                                        border: state.isFocused
                                          ? "2px solid #007bff"
                                          : "1px solid #ced4da",
                                        borderRadius: "8px",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "#007bff",
                                        },
                                      }),
                                      placeholder: (provided: any) => ({
                                        ...provided,
                                        color: "#6c757d",
                                        fontSize: "14px",
                                      }),
                                      input: (provided: any) => ({
                                        ...provided,
                                        fontSize: "14px",
                                        padding: "8px 0",
                                      }),
                                      menu: (provided: any) => ({
                                        ...provided,
                                        borderRadius: "8px",
                                        boxShadow:
                                          "0 4px 12px rgba(0, 0, 0, 0.15)",
                                        border: "1px solid #e9ecef",
                                      }),
                                      option: (provided: any, state: any) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected
                                          ? "#007bff"
                                          : state.isFocused
                                          ? "#f8f9fa"
                                          : "white",
                                        color: state.isSelected
                                          ? "white"
                                          : "#333",
                                        padding: "12px 16px",
                                        fontSize: "14px",
                                        "&:hover": {
                                          backgroundColor: state.isSelected
                                            ? "#007bff"
                                            : "#e9ecef",
                                        },
                                      }),
                                      singleValue: (provided: any) => ({
                                        ...provided,
                                        fontSize: "14px",
                                        color: "#333",
                                      }),
                                      clearIndicator: (provided: any) => ({
                                        ...provided,
                                        color: "#6c757d",
                                        "&:hover": {
                                          color: "#dc3545",
                                        },
                                      }),
                                    },
                                  }}
                                />
                                {!formik.values.venueDetails?.name &&(
                                <div className="location-help-text">
                                  <i className="fa-solid fa-info-circle me-2"></i>
                                  <small className="text-muted">
                                    Start typing to search for venues,
                                    addresses, or landmarks
                                  </small>
                                </div>
                                )}

                              </div >
                              {formik.values.venueDetails?.name && (
                                <div className="selected-location mt-3">
                                  <div className="card">
                                    <div className="card-body">
                                      <h6 className="mb-2">
                                        Selected Location
                                      </h6>
                                      <div className="location-details">
                                        <p className="mb-1">
                                          <i className="fa-solid fa-location-dot me-2"></i>
                                          {formik.values.venueDetails.name}
                                        </p>
                                        {formik.values.venueDetails.addressLine1 && (
                                          <p className="mb-1 text-muted small">
                                            <i className="fa-solid fa-map-marker-alt me-2"></i>
                                            {formik.values.venueDetails.addressLine1}
                                          </p>
                                        )}
                                        {formik.values.venueDetails.city && (
                                          <p className="mb-0 text-muted small">
                                            <i className="fa-solid fa-city me-2"></i>
                                            {formik.values.venueDetails.city}
                                            {formik.values.venueDetails.state &&
                                              `, ${formik.values.venueDetails.state}`}
                                            {formik.values.venueDetails.country &&
                                              `, ${formik.values.venueDetails.country}`}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* <GoogleMapPicker
                              value={{
                                latitude: undefined, // You can add these to your form data if needed
                                longitude: undefined,
                                formattedAddress: formData.venueDetails.name + ' ' + formData.venueDetails.addressLine1,
                                name: formData.venueDetails.name,
                                
                              }}
                              onChange={handleSingleVenueLocationChange}
                              onBlur={() => formik.setFieldTouched('eventLocation', true)}
                              invalid={isFieldInvalid(formik.touched, formik.errors, 'addressLine1')}
                              error={getFieldError(formik.touched, formik.errors, 'addressLine1')}
                            /> */}
                            </div>                                
                                {/* <div className=" form-group  border_bottom pb_30">
                                  <label className="form-label mt-3 fs-6">
                                    Select Country.*
                                  </label>
                                  <Select
                                    className="eventox-select"
                                    options={countries.map((country: any) => ({
                                      value: country.countryId,
                                      label: country.countryName,
                                    }))}
                                    styles={colourStyles}
                                    onChange={(val) =>
                                      formik.setFieldValue(
                                        "countryName",
                                        (val as { value: string })?.value || ""
                                      )
                                    }
                                  />
                                  {formik.touched.countryName &&
                                    formik.errors.countryName && (
                                      <div className="text-danger">
                                        {formik.errors.countryName}
                                      </div>
                                    )}
                                </div>
                                <div className="form-group pt_30 border_bottom pb_30">
                                  <label className="form-label fs-16">
                                    Where is your event taking place? *
                                  </label>
                                  <input
                                    className="form-control h_50"
                                    type="text"
                                    placeholder="Enter event location here"
                                    name="eventLocation"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.eventLocation}
                                  />
                                  {formik.touched.eventLocation &&
                                    formik.errors.eventLocation && (
                                      <div className="text-danger">
                                        {formik.errors.eventLocation}
                                      </div>
                                    )}
                                </div> */}
                                <div className="p-4 form-group border_bottom pb_30">
                                <div className="">
                                  <div className="ticket-section">
                                    <label className="form-label fs-16">Let's create tickets!</label>
                                    <p className="mt-2 fs-14 d-block mb-3 pe_right">
                                      Create tickets for your event by clicking on the 'Add Tickets' button below.
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between pt-4 pb-3 full-width">
                                    <h3 className="fs-18 mb-0">Tickets (<span className="venue-event-ticket-counter">{ticket.length}</span>)</h3>
                                    <div className="dropdown dropdown-default dropdown-normal btn-ticket-type-top">
                                      <button className="dropdown-toggle main-btn btn-hover h_40 pe-4 ps-4" type="button">
                                        <span>Add Tickets</span>
                                      </button>
                                      <div className="dropdown-menu dropdown-menu-right">
                                        <a 
                                          className="dropdown-item" 
                                          href="#" 
                                          onClick={(e) => {
                                            e.preventDefault();
                                            openModal('single');
                                          }}
                                        >
                                          <i className="fa-solid fa-ticket me-2"></i>
                                          Single Ticket
                                        </a>
                                        <a 
                                          className="dropdown-item" 
                                          href="#" 
                                          onClick={(e) => {
                                            e.preventDefault();
                                            openModal('group');
                                          }}
                                        >
                                          <i className="fa-solid fa-ticket me-2"></i>
                                          Group Ticket
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <TicketList
                                      tickets={ticket}
                                      hasMultipleVenues={hasMultipleVenues}
                                      venues={venues}
                                      hasMultipleTicketGroups={hasMultipleTicketGroups}
                                      ticketGroups={ticketGroups}
                                      onTicketToggle={handleTicketToggle}
                                      onEditTicket={onEditTicket}
                                      onDeleteTicket={onDeleteTicket}
                                    />
                                </div>
                              </div>
                              <div className="form-group pt_30 pb_30">
                                  <h4 className="form-label fs-18 mb-4">Event Settings</h4>
                                  
                                  {/* Require information for all attendees */}
                                  <div className="setting-item border_bottom pb_30 pt-4">
                                    <div className="d-flex align-items-start">
                                      <label className="btn-switch m-0 me-3">
                                        <input
                                          type="checkbox"
                                          checked={formik.values.isOtherAttendeeRequired}
                                          onChange={(e) => onCheckboxChange('isOtherAttendeeRequired', e.target.checked)}
                                        />
                                        <span className="checkbox-slider"></span>
                                      </label>
                                      <div className="d-flex flex-column">
                                        <label className="color-black fw-bold mb-1">Require information for all attendees.</label>
                                        <p className="mt-2 fs-14 d-block mb-0">When enabled, customers must provide information for each ticket holder. When disabled, only the primary attendee information is required.</p>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Terms & Conditions */}
                                  <div className="setting-item border_bottom pb_30 pt_30">
                                    <div className="d-flex align-items-start">
                                      <label className="btn-switch m-0 me-3">
                                        <input
                                          type="checkbox"
                                          checked={formik.values.hasTermsAndConditions}
                                          onChange={(e) => onCheckboxChange('hasTermsAndConditions', e.target.checked)}
                                        />
                                        <span className="checkbox-slider"></span>
                                      </label>
                                      <div className="d-flex flex-column">
                                        <label className="color-black fw-bold mb-1">Add Terms & Conditions for ticket booking</label>
                                        <p className="mt-2 fs-14 d-block mb-0">When enabled, customers must agree to your terms and conditions before completing their booking.</p>
                                      </div>
                                    </div>
                                    {formik.values.hasTermsAndConditions && (
                                      <div className="terms-holder pt-4">
                                        <ReactQuill
                                          className="text-editor mt-4 h_200"
                                          value={formik.values.termsAndConditions}
                                          onChange={(value) => formik.setFieldValue("termsAndConditions", value)}
                                          onBlur={() => formik.setFieldTouched("termsAndConditions", true)}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>                              

                                {/* Submit Button */}
                                <div className="col-md-12 pt_30 pb_30">
                                  <button
                                    className="gradient-button mt-3 w-100 h_50"
                                    type="submit"
                                    disabled={isLoading}
                                  >
                                    <h5>
                                      {isLoading
                                        ? "Creating Event..."
                                        : "Create Event"}
                                    </h5>
                                  </button>
                                </div>
                                <div>
                                  <ToastContainer
                                  autoClose={2000}
                                  />
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewTicketModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onSubmit={handleTicketSubmit}
        isLoading={isLoading}
        ticketKind={ticketKind}   
        hasMultipleVenues={hasMultipleVenues}
        venues={venues}
        hasMultipleTicketGroups={hasMultipleTicketGroups}
        ticketGroups={ticketGroups}
        isTicketFree={isTicketFree}
        editingTicket={editingTicket}
        type={type}
      />
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        isOpen={confirmationDialog.isOpen}
        toggle={closeConfirmationDialog}
        onConfirm={confirmationDialog.onConfirm}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        type={confirmationDialog.type}
        confirmText="Yes, Continue"
        cancelText="Cancel"
        icon="fa-solid fa-exclamation-triangle"
      />
    </div>
  );
};
export default CreateCalEvent;